<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-3">
              <!--  -->
              <div class="d-flex">
                <Sidepanel :reference="$refs" />
                <Mainview ref="mainview" />
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import Sidepanel from "./CategoriesSidepanel.vue";
import Mainview from "./CategoriesMainview.vue";

export default {
  name: "Categories",
  data() {
    return {
      reference: this.$refs.mainview,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    Sidepanel,
    Mainview,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "categories",
        activeMenu: this.activeMenu ? this.activeMenu : "productandsuppliers",
      });
    },
  },
  created() {
    this.$store.commit("categories/SET_PAGE_NUMBER", 1);
    this.$store.commit("categories/SET_HEADING_LABEL", "");
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
